<template>
  <div class="job-list-container">
    <FilterLayout
      ref="filterList"
      class="filter-layout"
      hiddenKeywordSearch
      hiddenMyCandidateSwitch
      hiddenCandidateIdSearch
      hiddenCandidateNameSearch
      hiddenEmployeeIdSearch
      :searchTemplate.sync="searchTemplate"
      :searchTemplateList="searchTemplateList"
      :filterGroupList="filterList"
      :listLoading="loading"
      :candidateTotalCount="0"
      @search="handelSearch"
      @createSearchTemplate="handleCreateSearchTemplate"
      @updateSearchTemplate="handleUpdateSearchTemplate"
      @clearSearchTemplate="handleClearSearchTemplate"
      @deleteSearchTemplate="handleDeleteSearchTemplate"
    >
      <template #selectCountContainer>
        <div class="left-container">
          <div class="job-count-container">
            <span class="job-count total-count">
              {{ `${$t(`${i18nPrefix}.label.totalCount`)} ${formatBigNumber(pageSetting.total)}` }}
            </span>
          </div>
        </div>
      </template>
      <template #headBtnContainer>
        <div class="right-container">
          <div class="date-order-container" @click="handelDateClick">
            <span class="date-order-label">{{ $t(`${i18nPrefix}.label.date`) }}</span>
            <div class="date-order-icon">
              <i class="el-icon-caret-top" :class="dateOrder === 'up' && 'select'"/>
              <i class="el-icon-caret-bottom" :class="dateOrder === 'down' && 'select'"/>
            </div>
          </div>
        </div>
      </template>
      <template #listContainer>
        <div class="list-body">
          <div class="job-list-box" v-infinite-scroll="loadJobs" :infinite-scroll-immediate="false" :infinite-scroll-disabled="pageSetting.disabledLoad">
            <JobItem
              class="job-item"
              v-for="(item, index) in jobs"
              :key="index"
              :jobObj="item"
            />
          </div>
          <div class="no-data-tips" v-show="!loading && jobs.length === 0">{{ $t('el.table.emptyText') }}</div>
        </div>
      </template>
    </FilterLayout>
    <ConfirmDialog
      v-if="confirmDialog.show"
      :content="confirmDialog.content"
      :show.sync="confirmDialog.show"
      :title="confirmDialog.title"
      :loading="confirmDialog.loading"
      @confirm="confirmDialog.confirmMethod"
      @cancel="confirmDialog.cancelMethod"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { formatBigNumber } from '@/components/filters'
import FilterLayout from '../../adminNew/applicantList/filterList/layout.vue'
import JobItem from './components/jobListItem.vue'
import ConfirmDialog from '@/components/dialog/confirmDialog.vue'
import { addI18nProperty } from '@/i18n'
import { MUNICIPALITY_CITY, MUNICIPALITY_PROVINCE } from '@/constant/application'
import { JOB_STATUS } from '@/constant/job'

const JOB_LIST_FILTER_GROUP_INDEX = 0

export default {
  components: {
    JobItem,
    FilterLayout,
    ConfirmDialog
  },
  data () {
    return {
      i18nPrefix: 'admin.job.list',
      formatBigNumber,
      checkAllStatus: false,
      isIndeterminate: false,
      loading: false,
      checkedJobIds: [],
      jobFilterField: {
        keyword: '',
        companyId: '',
        location: [],
        status: '0'
      },
      dateOrder: 'down',
      pageSetting: {
        pageSize: 10,
        page: 1,
        total: 0,
        disabledLoad: true
      },
      jobList: [],
      companyList: [],
      candidateStatusGroup: [],
      currentCompany: {},
      selectCompany: {},
      confirmDialog: {
        show: false,
        title: '',
        content: '',
        confirmMethod: null,
        cancelMethod: null,
        loading: false
      },
      addCompanyId: null,
      searchTemplate: null,
      searchTemplateList: [],
      isSavingSearchTemplate: false,
      location: {
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      totalParamsList: ['companyId', 'keyword', 'location', 'status'],
      multipleParamsList: ['location']
    }
  },
  computed: {
    jobStatusList () {
      const list = []
      _.forEach(JOB_STATUS, (val, key) => {
        if (val !== 3) {
          list.push({
            label: this.$t(`${this.i18nPrefix}.label.jobStatus.${key}`),
            value: `${val}`
          })
        }
      })
      return list
    },
    jobs () {
      const jobList = []
      const checkedJobIds = this.checkedJobIds
      _.forEach(this.jobList, (item) => {
        this.$set(item, 'checked', false)
        if (this.checkAllStatus || checkedJobIds.includes(item.id)) {
          item.checked = true
          if (this.checkAllStatus && !checkedJobIds.includes(item.id)) {
            checkedJobIds.push(item.id)
          }
        }
        this.initCandidateStatusCount(item)
        jobList.push(item)
      })
      return this.jobList
    },
    selectedCount () {
      if (this.checkAllStatus) {
        return this.pageSetting.total
      }
      return this.checkedJobIds.length
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    filterList () {
      const vm = this
      const list = [
        {
          title: this.$t(`${this.i18nPrefix}.label.jobInfo`),
          filterList: {
            keyword: {
              elType: 'el-input',
              label: this.$t(`${this.i18nPrefix}.label.jobTitle`)
            },
            company: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.company`),
              optionLabel: 'i18nName',
              optionValue: 'id',
              optionSearch: true,
              style: (company) => {
                return { 'padding-left': `${(company.level || 1) * 15}px` }
              },
              loader: this.loadCompanyList
            },
            location: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.jobLocation`),
              optionLabel: 'locationName',
              optionValue: 'id',
              multiple: true,
              optionSearch: this.loadLocationList,
              loadTemplate: this.loadLocationTemplate,
              loader: this.getLocationList,
              loadMore: (filter) => {
                const location = vm.location
                if (location.currentData && location.page * location.pageSize > location.currentData.length) {
                  return
                }
                const data = location.currentData.slice(location.page * location.pageSize, (location.page + 1) * location.pageSize)
                location.page += 1
                filter.option.data.push(...data)
              },
              props: {
                popperClass: 'location-dropdown',
                noDataText: this.$t('admin.application.applicantList.label.pleaseStartTyping')
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible) {
                    if (filter) {
                      filter.option.data = []
                    }
                  }
                }
              }
            },
            status: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.jobStatus.label`),
              optionValue: 'value',
              optionList: this.jobStatusList
            }
          }
        }
      ]
      return list
    }
  },
  async created () {
    this.loading = true
    await this.initCompanyList()
    this.initJobListFilter()
    this.loadSearchTemplateList()
  },
  methods: {
    ...mapActions('agency', ['getAgencyJobList', 'getAgencyJobCompanyList']),
    ...mapActions('worldLocation', ['getWorldLocationList']),
    ...mapActions('account', ['getAccountPageConfigList', 'createAccountPageConfig', 'updateAccountPageConfig', 'deleteAccountPageConfig']),
    async initCompanyList () {
      const resp = await this.getAgencyJobCompanyList()
      if (resp) {
        this.companyList = this.buildTreeFromArray(resp)
      }
    },

    loadCompanyList () {
      addI18nProperty()
      const list = this.formatCompanyData(this.companyList)
      return list
    },
    formatCompanyData (companyList) {
      const list = []
      _.forEach(companyList, company => {
        list.push(company)
        if (company.children && company.children.length > 0) {
          list.push(...this.formatCompanyData(company.children))
        }
      })
      return list
    },
    findChildren (parentId, array, level) {
      level += 1
      const children = []
      _.forEach(array, item => {
        if (item.parent_id === parentId) {
          addI18nProperty(item, 'i18nName', 'cn_name', 'name')
          const childNode = {
            ...item,
            level: level,
            children: this.findChildren(item.id, array, level)
          }
          children.push(childNode)
        }
      })
      return children
    },
    buildTreeFromArray (array) {
      const tree = []

      _.forEach(array, item => {
        const level = 1
        if (!_.find(array, element => element.id === item.parent_id)) {
          addI18nProperty(item, 'i18nName', 'cn_name', 'name')
          const rootNode = {
            ...item,
            level: level,
            children: this.findChildren(item.id, array, level)
          }
          tree.push(rootNode)
        }
      })

      return tree
    },
    async initCompanyJobList () {
      this.jobList = await this.loadCompanyJobList(1)
      this.pageSetting.disabledLoad = false
    },
    initJobListFilter () {
      const query = this.$route.query
      const jobFilterField = this.jobFilterField
      jobFilterField.status = '2'
      const totalParamsList = this.totalParamsList
      const multipleParamsList = this.multipleParamsList
      _.forEach(query, (value, key) => {
        if (value && multipleParamsList.includes(key)) {
          jobFilterField[key] = _.map(value.split(','), (item) => _.toInteger(item))
        } else if (totalParamsList.includes(key)) {
          jobFilterField[key] = value
        }
      })
      this.$nextTick(() => {
        const search = this.$refs.filterList.search
        search[JOB_LIST_FILTER_GROUP_INDEX].keyword = jobFilterField.keyword
        search[JOB_LIST_FILTER_GROUP_INDEX].company = jobFilterField.companyId
        search[JOB_LIST_FILTER_GROUP_INDEX].location = jobFilterField.location
        search[JOB_LIST_FILTER_GROUP_INDEX].status = jobFilterField.status
        this.$refs.filterList.resetSearch({ search })
      })
    },
    async loadCompanyJobList (currentPage) {
      this.loading = true
      let jobList = []
      const jobFilterParams = this.getJobFilterForSearch()
      try {
        const params = { page: currentPage, ...jobFilterParams }
        const resp = await this.getAgencyJobList(params)
        if (resp && resp.job_list) {
          jobList = resp.job_list
          this.pageSetting.total = resp.total
          this.addCompanyId = resp.add_company_id
          this.selectCompany = resp.company_info
          if (!this.candidateStatusGroup || this.candidateStatusGroup.length === 0) {
            this.candidateStatusGroup = resp.group_info_list
          }
        }
      } finally {
        this.loading = false
      }
      return jobList
    },
    async loadJobs () {
      this.pageSetting.disabledLoad = true
      this.pageSetting.page++
      const companyJobList = await this.loadCompanyJobList(this.pageSetting.page)
      this.jobList = _.concat(this.jobList, companyJobList)
      if (this.pageSetting.total > this.pageSetting.page * this.pageSetting.pageSize) {
        this.pageSetting.disabledLoad = false
      }
    },
    handelCheckedJob (jobObj) {
      if (!jobObj.checked) {
        if (!this.checkedJobIds.includes(jobObj.id)) {
          this.checkedJobIds.push(jobObj.id)
        }
        jobObj.checked = true
        this.checkAllStatus = this.checkedJobIds.length === this.jobs.length
        this.isIndeterminate = !this.checkAllStatus
      } else {
        this.checkedJobIds.splice(this.checkedJobIds.indexOf(jobObj.id), 1)
        jobObj.checked = false
        this.checkAllStatus = false
        this.isIndeterminate = this.checkedJobIds.length > 0
      }
    },
    handelSelectAll (val) {
      const jobList = this.jobs
      this.isIndeterminate = false
      _.forEach(jobList, (item) => {
        item.checked = val
        if (val && !this.checkedJobIds.includes(item.id)) {
          this.checkedJobIds.push(item.id)
        } else if (!val) {
          this.checkedJobIds.splice(this.checkedJobIds.indexOf(item.id), 1)
        }
      })
    },
    initCandidateStatusCount (jobObj) {
      const statusGroup = this.candidateStatusGroup
      const applicantInfo = jobObj.applicant_info
      const statusCountGroup = []
      _.forEach(statusGroup, (group) => {
        const statusList = []
        let groupCount = 0
        _.forEach(group.status_list, (status) => {
          const statusCount = applicantInfo[status.key] || 0
          groupCount += statusCount
          statusList.push({ ...status, count: statusCount, label: this.isEn ? status.name_en : status.name_cn })
        })
        statusCountGroup.push({ name: group.name, statusList: statusList, count: groupCount })
      })
      jobObj.statusCountGroup = statusCountGroup
    },
    async handelChangeFilter () {
      this.pageSetting.disabledLoad = true
      this.checkAllStatus = false
      this.checkedJobIds = []
      this.jobList = []
      this.pageSetting.page = 1
      this.pageSetting.total = 0
      this.jobList = await this.loadCompanyJobList(this.pageSetting.page)
      if (this.pageSetting.total > this.pageSetting.page * this.pageSetting.pageSize) {
        this.pageSetting.disabledLoad = false
      }
    },
    handelDateClick () {
      this.dateOrder = this.dateOrder === 'up' ? 'down' : 'up'
      this.handelChangeFilter()
    },
    handelCancelCloseJob () {
      this.$message.info(this.$t(`${this.i18nPrefix}.message.cancelAction`))
    },
    async loadLocationList (keywords, loadData, valueList) {
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      if (this.location.loader) {
        await this.location.loader
      }
      const filteredList = _.filter(this.location.data, location => {
        if (valueList?.length > 0) {
          return _.includes(valueList, location.id)
        } else {
          const keywordsList = _.map(location.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      this.location.page = 1
      this.location.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, this.location.pageSize)
    },
    async loadLocationTemplate (valueList, filter, formattedFilterValues) {
      if (valueList?.length < 1) {
        return []
      }
      const locationList = await this.loadLocationList(null, null, valueList)
      if (locationList.length > 0) {
        filter.option.data = locationList
        formattedFilterValues.location = locationList
      }
    },
    async getLocationList () {
      if (this.location.hasLoad) {
        return
      }
      this.location.hasLoad = true
      this.location.loader = this.getWorldLocationList().then(resp => {
        if (!resp) {
          return
        }
        this.location.data = _.map(resp, location => {
          addI18nProperty(location, 'i18nName', 'cn_name', 'name')
          location.searchTextList = []
          location.searchTextList.push(location.name, location.cn_name, location.pinyin_name)
          if (location.parent_id) {
            const locationInfo = _.find(resp, item => item.id === location.parent_id)
            location.parent = locationInfo
            location.searchTextList.push(locationInfo.name, locationInfo.cn_name, locationInfo.pinyin_name)
          }
          // 处理四个直辖市, 不出现在下拉列表中
          if (_.findKey(MUNICIPALITY_CITY, city => city === location.id)) {
            location.searchTextList = null
          }
          if (location.type_code === 'region') {
            location.searchTextList = null
          }
          const nameList = []
          if (location.parent) {
            this.getParentLocation(location, nameList)
          }
          location.locationName = _.chain([location.i18nName, ...nameList]).filter().join(' - ').value()
          return location
        })
        this.location.loader = null
      })
    },
    getParentLocation (location, nameList) {
      const parent = location.parent
      if (parent) {
        if (parent.searchTextList) {
          nameList.push(parent.i18nName)
        }
        if (parent.parent_id) {
          this.getParentLocation(parent, nameList)
        }
      }
    },
    async handleCreateSearchTemplate (template, callback) {
      if (this.isSavingSearchTemplate) {
        return
      }
      this.isSavingSearchTemplate = true
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.createAccountPageConfig({
          page_type: 'AGENCY_JOB_LIST',
          config: {
            name: template.name,
            search: template.search
          }
        })
        if (resp) {
          const templateInfo = {
            _config: resp,
            id: resp.id,
            name: resp.config.name,
            search: resp.config.search
          }
          callback(templateInfo)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSavingSearchTemplate = false
      }
    },
    async handleUpdateSearchTemplate (template, callback) {
      if (this.isSavingSearchTemplate) {
        return
      }
      this.isSavingSearchTemplate = true
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.updateAccountPageConfig({
          id: template._config.id,
          config: {
            name: template.name,
            search: template.search
          }
        })
        if (resp) {
          const templateInfo = {
            _config: resp,
            id: resp.id,
            name: resp.config.name,
            search: resp.config.search
          }
          callback(templateInfo)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSavingSearchTemplate = false
      }
    },
    async handleClearSearchTemplate () {
      this.searchTemplate = null
    },
    async handleDeleteSearchTemplate (searchTemplate, deletedTemplateIndex) {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.deleteAccountPageConfig({
          id: searchTemplate.id
        })
        if (resp) {
          this.searchTemplateList.splice(deletedTemplateIndex, 1)
          this.$message({
            type: 'success',
            message: this.$t(`${this.i18nPrefix}.message.deleteSuccess`)
          })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async loadSearchTemplateList () {
      const resp = await this.getAccountPageConfigList({ page_type: 'AGENCY_JOB_LIST' })
      if (resp) {
        this.searchTemplateList = _.map(resp, pageConfig => {
          return {
            _config: pageConfig,
            id: pageConfig.id,
            name: pageConfig.config.name,
            search: pageConfig.config.search
          }
        })
      }
    },
    formatSearchParams (search) {
      const params = search[JOB_LIST_FILTER_GROUP_INDEX]
      const result = {}
      result.companyId = params.company?.id || ''
      result.keyword = params.keyword
      result.location = _.map(params.location, (item) => item.id)
      result.status = params.status?.value || '0'
      return result
    },
    handelSearch (search, nextPage) {
      this.jobFilterField = this.formatSearchParams(search)
      this.updateFilterToUrl()
      this.handelChangeFilter()
    },
    getJobFilterForSearch () {
      const jobLocation = this.getMunicipalityCityId()
      return {
        page_size: this.pageSetting.pageSize,
        job_type: this.jobFilterField.status,
        keyword: this.jobFilterField.keyword,
        company_id: this.jobFilterField.companyId,
        location: jobLocation.join(','),
        order: this.dateOrder
      }
    },
    getMunicipalityCityId () {
      const locationList = []
      _.forEach(this.jobFilterField.location, (locationId) => {
        const cityName = _.findKey(MUNICIPALITY_PROVINCE, city => city === locationId)
        locationList.push(locationId)
        if (cityName) {
          locationList.push(MUNICIPALITY_CITY[cityName])
        }
      })
      return locationList
    },
    updateFilterToUrl () {
      const filterQuery = { ...this.$route.query }
      _.forEach(this.jobFilterField, (value, key) => {
        filterQuery[key] = this.multipleParamsList.includes(key) ? value.join(',') : value
      })
      this.$router.push({ path: this.$router.path, query: filterQuery })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.job-list-container {
  width: 100%;
  display: flex;
  position: relative;
  height: 100%;

  .filter-layout {
    width: 100%;
  }

  .filter-container {
    margin-left: -20px;
    flex-shrink: 0;
  }

  .job-filter-container {
    width: 252px;
    height: 100%;
    padding: 20px;
    border: 1px solid #eef2f4;
    border-radius: 6px;
    background: #F7F8FA;
    overflow: auto;

    .item-container {
      padding: 14px 0;
      border-bottom: 1px solid #E7EAEB;
      .label {
        font-size: 16px;
        font-weight: bold;
        color: #606266;
        margin-bottom: 10px;
        display: block;
      }
    }
  }

  .left-container {
    display: flex;
    align-items: baseline;
    font-size: 14px;
    margin-right: 10px;

    .select-all {
      line-height: 32px;
      margin-right: 4px;
    }

    .job-count-container {
      display: flex;

      .job-count {
        padding: 6px 20px;
        border: 1px solid #dddedf;
        color: #303133 ;
        border-radius: 4px 4px 0 0;
        line-height: 18px;
        margin-bottom: 14px;
      }
    }

    .filter-keyword-container {
      > span {
        padding: 6px 20px;
        color: #303133 ;
        border-radius: 18px;
        line-height: 18px;
        margin-left: 10px;
        border: 1px solid #dddedf;

        .btn-icon {
          cursor: pointer;
          margin-left: 5px;
        }
      }
    }
  }

  .right-container {
    color: #606266;
    margin-left: 16px;
    margin-right: 0;

    .date-order-container {
      cursor: pointer;
      display: inline-flex;
      vertical-align: middle;
      align-items: center;
    }

    .date-order-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 28px;
      width: 14px;
      font-size: 12px;
      margin-left: 6px;
      margin-right: 24px;
      vertical-align: middle;
      justify-content: center;
      overflow: initial;
      color: #909399;

      .el-icon-caret-top {
        margin-bottom: -3px;
      }

      .select {
        color: #0096CC;
      }

      .el-icon-caret-bottom {
        margin-top: -3px;
      }
    }

    .more {
      margin-left: 18px;
    }

    .dropdown-btn {
      padding: 6px 14px;
      display: inline-block;
      vertical-align: middle;
      border-color: #0096CC;
      color: #0096CC;

      .label {
        font-size: 14px;
        line-height: 20px;
        height: 20px;
      }
    }

    .iconAdd {
      display: inline-block;
      vertical-align: middle;
      font-size: 34px;
      cursor: pointer;
      color: #0096CC;
      height: unset;
      margin-left: 24px;
      line-height: unset;

      &.disabled {
        color: #ccc;
      }
    }
  }

  .list-body {
    margin-top: 14px;
    overflow: auto;
    height: calc(100% - 15px);
    position: relative;

    .job-list-box {
      min-width: 1000px;
    }

    .job-item {
      margin-bottom: 15px;
    }

    .loading {
      position: absolute;
    }

    .no-data-tips {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #909399;
      height: 100%;
    }
  }

  ::v-deep .el-checkbox {
    .el-checkbox__input {
      zoom: 120%;
    }
  }
}
</style>
<style lang="scss">
.job-list-dropdown-container {
  &.el-popper {
    .popper__arrow {
      display: none;
    }
  }
}

.el-message-box__wrapper {
  .close-job-confirm {
    overflow: unset;
    position: relative;
    border: 0;
    box-shadow: unset;

    &::before {
      content: '';
      width: 10px;
      height: 100%;
      background: #666666;
      position: absolute;
      top: 0;
      left: -6px;
    }
  }
}
.el-dropdown-menu {
  .el-dropdown-menu__item {
    &:not(.is-disabled) {
      &:hover {
        background: #F0F0F0;
        color: #606266;
      }
    }
  }
}
</style>
